import type { ApplicationBase } from "../types";

export enum ApplicationTypes {
  MachineLogic = 'machinelogic',
  Python = 'python',
  MachineApp = 'injectable_machineapp',
  GeneratedMachineApp = 'generated_machineapp'
}

const MACHINELOGIC_APPLICATION_TYPES_LIST = [ApplicationTypes.MachineLogic, ApplicationTypes.MachineApp, ApplicationTypes.GeneratedMachineApp];

export function isMachineLogicApplication(application: ApplicationBase) {
  return MACHINELOGIC_APPLICATION_TYPES_LIST.includes(application.getType());
}